<template>
  <div class="centered">
    <table class="centered">
      <thead>
      <tr>
        <td rowspan="2" style="text-align:right;">
          <a href="https://www.prairiefarms.com" target="_blank">
            <img class="boastful-logo-style"
                 alt="Prairie Farms Dairy"
                 src="@/assets/img/brands/PrairieFarms.png"/>
          </a>
        </td>
        <td style="vertical-align:bottom;">
          <div style="text-align:left;">
            <span class="page-title">Customer Orders</span>
            <span class="app-version">v{{ appVersion }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td style="vertical-align:top;">
          <div class="page-style">
            <a href="https://www.hilanddairy.com/" target="_blank">
              <img class="logo-style"
                   alt="Hiland Dairy"
                   src="@/assets/img/brands/HilandDairy.png"/>
            </a>
            <a href="https://www.belfontedairy.com/" target="_blank">
              <img class="logo-style"
                   alt="Belfonte Ice Cream Dairy"
                   src="@/assets/img/brands/Belfonte.png"/>
            </a>
            <a href="https://www.prairiefarms.com" target="_blank">
              <img class="logo-style"
                   alt="PFD Supply"
                   src="@/assets/img/brands/PFDSupply.png"/>
            </a>
            <a href="https://northstarfrozentreats.com/" target="_blank">
              <img class="logo-style"
                   alt="NorthStar"
                   src="@/assets/img/brands/NorthStar.png"/>
            </a>
          </div>
        </td>
      </tr>
      </thead>
    </table>
    <div v-if="username">
      <span>Welcome, {{ username }}</span>
    </div>
    <div>
      <button v-if="username"
              v-on:click="$emit('logout')"
              type="button">sign out
      </button>
    </div>
  </div>
</template>

<script>
import packageInfo from '../../package.json';

export default {
  name: 'HeaderComponent',
  props: ['username', 'role'],
  emits: ['logout'],
  data: function () {
    return {
      appVersion: packageInfo.version,
    }
  },
}
</script>

<style scoped>
table, th, td {
  width:35%;
  padding: 0;
  border: none;
  border-collapse:collapse;
}

.page-style {
  display: flex;
  justify-content: flex-start;
}

.page-title {
  font-weight: bold;
  font-size: x-large;
}

.app-version {
  padding-left: 5px;
  vertical-align: top;
  font-size: 8pt;
  font-style: italic;
}

.boastful-logo-style {
  width: 150px;
  height: auto;
}

.logo-style {
  width: 55px;
  height: auto;
}

.login-username-style {
  color: darkgrey;
  font-weight: bold;
  font-style: italic;
}
</style>
